import { FnolInboxRecordFnolInboxStatus } from '~/server_shared/openapi/data-contracts';

export const DISABLED_STATUSES_SET = new Set([
  FnolInboxRecordFnolInboxStatus.Dismissed,
  FnolInboxRecordFnolInboxStatus.Created,
  FnolInboxRecordFnolInboxStatus.Attached,
]);

export const AI_PROCESSING_STATUSES_SET = new Set([
  FnolInboxRecordFnolInboxStatus.AiNew,
  FnolInboxRecordFnolInboxStatus.AiPolicyNotFound,
  FnolInboxRecordFnolInboxStatus.AiProcessing,
  FnolInboxRecordFnolInboxStatus.AiProcessingFailed,
]);

export const FNOL_INBOX_TAB_STORAGE_KEY = 'fnol_inbox_tab';

// Navigating straight to a tab keeps the FNOL page's own address off the tab strip's redirect path.
export const getFnolInboxPath = (): string => {
  const tabUrl = sessionStorage.getItem(FNOL_INBOX_TAB_STORAGE_KEY);
  return tabUrl ? `/fnol/${tabUrl}` : '/fnol';
};
